export function googleReCaptcaSiteKey() {
    return "6LeD6KwcAAAAAEBllGiTd1jKIb5pl54rzBSTj8aT";
}